export type CashRecommendationEventType = "cash" | "commitment" | "opportunity"

export interface CashRecommendationEntry {
    loading: boolean
    error: string | null
    data: any
}

export interface CashRecommendationState {
    byKey: Record<string, CashRecommendationEntry>
    setLoading: (account: string, eventType: CashRecommendationEventType, key?: string | number) => void
    setResult: (account: string, eventType: CashRecommendationEventType, data: any, key?: string | number) => void
    setError: (account: string, eventType: CashRecommendationEventType, error: string, key?: string | number) => void
    getEntry: (account: string, eventType: CashRecommendationEventType, key?: string | number) => CashRecommendationEntry | undefined
}

export const getStoreKey = (account: string, eventType: CashRecommendationEventType, key?: string | number) =>
    key === undefined || key === null || key === ""
        ? `${account}-${eventType}`
        : `${account}-${eventType}-${key}`
